import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';


const HomePage = () => {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/home-servizi');
  };

  return (
    <>
      <Helmet>
        <title>cliccami.net - Vivi la città. Sempre connessa.</title>
        <meta
          name="description"
          content="cliccami.net collega persone, negozi e servizi del tuo territorio. Scopri attività locali, ordina online e partecipa alla vita della città." />

      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Header */}
        <Header onFilterClick={() => {}} />

        {/* Hero Section */}
        <section className="relative w-full bg-[#fafaf8] overflow-hidden">
          {/* Subtle background graphic */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
            <svg className="w-full h-full" viewBox="0 0 1200 600" preserveAspectRatio="xMidYMid slice">
              <path d="M0 300 Q300 250 600 300 T1200 300" stroke="#2C1810" strokeWidth="2" fill="none" />
              <path d="M0 320 Q300 270 600 320 T1200 320" stroke="#2C1810" strokeWidth="1" fill="none" />
              <rect x="200" y="200" width="40" height="120" fill="#2C1810" opacity="0.5" />
              <rect x="500" y="180" width="50" height="140" fill="#2C1810" opacity="0.5" />
              <rect x="800" y="220" width="35" height="100" fill="#2C1810" opacity="0.5" />
            </svg>
          </div>

          <div className="relative max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16 lg:py-20">
            <div className="flex flex-col justify-center items-center gap-6">
              <div className="w-full max-w-4xl">
                <img
                  src="/assets/images/IconaStradaDonna-1769599991370.png"
                  alt="Cliccami.net"
                  className="w-full h-auto object-contain" />
              </div>
              <button
                onClick={handleCTAClick}
                className="px-8 py-4 bg-[#2C1810] text-white text-lg font-semibold rounded-lg hover:bg-[#3d2416] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                Esplora i servizi
              </button>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="w-full bg-background py-12 md:py-16 lg:py-20">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {/* Service 1 */}
              <div className="bg-card rounded-xl shadow-sm p-6 md:p-8 text-center hover:shadow-md transition-shadow">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Store" size={28} className="text-primary" />
                </div>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground mb-3">
                  Negozi e attività
                </h3>
                <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed">
                  Scopri le attività locali e resta in contatto diretto con il tuo territorio.
                </p>
              </div>

              {/* Service 2 */}
              <div className="bg-card rounded-xl shadow-sm p-6 md:p-8 text-center hover:shadow-md transition-shadow">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="ShoppingBag" size={28} className="text-primary" />
                </div>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground mb-3">
                  Food & Ordini
                </h3>
                <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed">
                  Ordina online, paga in sicurezza e ricevi direttamente da chi conosci.
                </p>
              </div>

              {/* Service 3 */}
              <div className="bg-card rounded-xl shadow-sm p-6 md:p-8 text-center hover:shadow-md transition-shadow">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Calendar" size={28} className="text-primary" />
                </div>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground mb-3">
                  Eventi e iniziative
                </h3>
                <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed">
                  Partecipa alla vita della città, promozioni, eventi e servizi.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>);

};

export default HomePage;